import React from 'react';
import { GetAppointmentsWithFeedbackRequiredDTO } from '@bb/domain/dist/types';
import { NoTasksSVG } from '@bb/elements-web';

import { Divider, Icon } from 'components';
import { featureEnabled } from 'utils';
import { EmptyContainer, EmptySection } from '../../components';
import FeedbackRequestedItem from './FeedbackRequestedItem';

type FeedbackSectionProps = {
  items: GetAppointmentsWithFeedbackRequiredDTO['appointments'];
};

const FeedbackSection: React.FC<FeedbackSectionProps> = ({ items }) => {
  if (!items.length) {
    if (featureEnabled('showingsMadeEasyFeature')) {
      return (
        <EmptySection
          dataCy="feedback-empty"
          Image={<NoTasksSVG width={133} height={120} />}
          mainText="No tasks yet"
          secondaryText="View incoming tasks that require your attention here."
        />
      );
    }
    return (
      <EmptyContainer data-cy="feedback-empty">
        <Icon type="quotationMark" width={32} color="gray6" offset={[0, 3]} />
        <span>No feedback to give</span>
      </EmptyContainer>
    );
  }

  return (
    <>
      {items.map((item, index) => {
        if (index === items.length - 1) {
          return <FeedbackRequestedItem key={index} appointment={item} />;
        }

        return (
          <React.Fragment key={index}>
            <FeedbackRequestedItem appointment={item} />{' '}
            <Divider style={{ margin: 0 }} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default FeedbackSection;
